const _ = require('lib/underscore')
const alertDialog = require('./dialog_alert')
const Escape = require('lib/escape')

const log = require('log').create('dialog', 'confirm') // eslint-disable-line


function confirmDialog(html, confirm_handler, options = {}) {
    if (! _.isFunction(confirm_handler)) throw new Error('Dialog.confirm requires a handler function.')

     
    let confirm_dialog

    _.defaults(options, {
        title: 'Confirmation',
        close_on_escape: false,
        glyph: 'question',
        open() {
            Escape.listen(this.cid, () => {
                this.close()
                confirm_handler.call(this, false)
            })
        },
        close() {
            Escape.unlisten(this.cid)
        },
        buttons: [
            {
                text: 'Yes',
                color: 'dark primary',
                className: 'fullwidth',
                default: true,
                onClick() {
                    confirm_handler.call(confirm_dialog, true)
                    confirm_dialog.close()
                },
            },
            {
                text: 'No',
                color: 'light secondary',
                className: 'fullwidth',
                onClick() {
                    confirm_handler.call(confirm_dialog, false)
                    confirm_dialog.close()
                },
            },
        ],
    })

    confirm_dialog = alertDialog(html, options)

    // call the handler with false if they click the dialog close button
    confirm_dialog.ui.close.on('click', () => {
        confirm_handler.call(confirm_dialog, false)
    })

    return confirm_dialog
}

module.exports = confirmDialog
